export default "__VITE_ASSET__LTNLrjVs__"